module.exports = __webpack_public_path__ + "static/media/IMG_3488_sm.dd960984.jpg";